export default {
  // 课程详情
  competitionCourseDetail: '/competition_course/detail',

  // 课程分类
  courseCategoryList: '/course_category/list',
  courseCategoryTree: '/course_category/tree',
  // 课程标签
  courseSignatureList: '/course_signature/list',

  // 入口页面详情
  competitionCoursePosterDetail: '/competition_course_poster/detail',

  // 登录注册
  authIsRegistered: '/auth/is-registered',
  authRegister: '/auth/register',
  authLogin: '/auth/login',
  authForgetPassword: '/auth/forget-password',

  // 管理活动通知、参赛说明。征集要求。学习资料。版权确认 competition_course_poster_id=&kind=notification/explain/requirement/study/sure
  competitionCourseInformationDetail: '/competition_course_information/detail',

  // 音频。视频。附件实例
  competitionCourseExampleDetail: '/competition_course_example/detail',

  // 自定义的字段
  competitionCourseFieldList: '/competition_course_field/list',

  // 预设课程文件。视频。音频分组名称，排序
  competitionCourseAudioDefaultGroupList: '/competition_course_audio_default_group/list',
  competitionCourseVideoDefaultGroupList: '/competition_course_video_default_group/list',
  competitionCourseFileDefaultGroupList: '/competition_course_file_default_group/list',

  // 自荐标签
  competitionCourseAuthorRecommendSignatureList: '/competition_course_author_recommend_signature/list',
  // 评价标签
  competitionCourseCommentSignatureList: '/competition_course_comment_signature/list',
}